import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ArrangementsHttpService } from '@backbase/arrangement-manager-http-ang';
import { take } from 'rxjs/operators';

@Component({
  selector: 'bn-transactions-list',
  templateUrl: './bn-transactions-list.component.html',
})
export class BnTransactionsListComponent implements OnInit {
  @Input() hostRef: any;
  @Output() showBalanceDataChange = new EventEmitter();
  @Output() transactionsTypeChange = new EventEmitter();
  showStatus = true;

  constructor(private arrangementsService: ArrangementsHttpService) {}

  ngOnInit() {
    this.setShowBalanceDataFromProductType();
  }

  setShowBalanceDataFromProductType(): void {
    const items = this.hostRef?.transactionsList?.items;
    if (items.length) {
      const arrangementId = items[0]?.arrangementId;
      this.arrangementsService
        .getArrangementById({ arrangementId })
        .pipe(take(1))
        .subscribe(
          (arrangement) => {
            this.transactionsTypeChange.emit(arrangement?.additions?.bankProductType);
            this.showBalanceDataChange.emit(arrangement?.additions?.bankProductType !== '94');
          },
          () => {
            this.showBalanceDataChange.emit(true);
          },
        );
    }
  }
}
